var fogExp4PS = `
#ifndef PCFOG
#define PCFOG
uniform vec3 fog_color;
uniform float fog_density;
float dBlendModeFogFactor = 1.0;
const float MIN_DEPTH = 75.0;
vec3 addFog(vec3 color) {
	float depth = gl_FragCoord.z / gl_FragCoord.w;
	float fogFactor = exp(-depth * depth * fog_density * fog_density * fog_density * fog_density);
	fogFactor = clamp(fogFactor, 0.0, 1.0);
	return mix(gammaCorrectInput(fog_color) * dBlendModeFogFactor, color, fogFactor);
}
#endif
`;

export { fogExp4PS as default };
